import { useEffect, useState } from "react";
import { useDidMountEffect } from "../../utils/utils";
import { adminEndpoints } from "../../api/endpoints";

export default function useAddClient(apiClient, isFocused = true) {
  const [clients, setClients] = useState(null);

  // pagination
  const [batch, setBatch] = useState(0);
  const [nPages, setNPages] = useState(null);
  const batchSize = 20;

  useDidMountEffect(() => {
    // run if 'batch' changes, but not on initial render
    loadData();
  }, [batch]);

  useEffect(() => {
    if (isFocused) initData();
    else clearData();
  }, [isFocused]);

  const loadData = () => {
    getClients();
  };

  const initData = () => {
    if (batch === 0) getClients();
    else setBatch(0);
  };

  const clearData = () => {
    setNPages(null);
    setClients(null);
  };

  const getClients = async () => {
    const params = {
      batch_size: batchSize,
      batch,
      assigned: false,
      order_by: "-latest_query_timestamp",
    };
    const response = await apiClient.get(adminEndpoints.client, params);
    setNPages(Number(response.headers.length));
    setClients(response.data);
  };

  return {
    data: { init: initData, update: loadData, clear: clearData },
    pagination: { nPages, page: batch, setPage: setBatch },
    clients,
  };
}
